export const Mail = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
      <path
        d="M13.7694 0.799805H2.23078C1.27539 0.799805 0.5 1.57487 0.5 2.52985V9.45004C0.5 10.405 1.27539 11.1801 2.23078 11.1801H13.7694C14.7248 11.1801 15.5002 10.405 15.5002 9.45004V2.52985C15.5002 1.57487 14.7248 0.799805 13.7694 0.799805ZM10.5784 5.9248L14.2742 9.70729L9.76606 6.48822L8.00008 7.63756L6.23294 6.48764L1.72539 9.70665L5.42179 5.92422L0.952313 2.4422L8.00008 6.2414L15.0473 2.4422L10.5784 5.9248Z"
        fill="#434343"
      />
    </svg>
  );
};
